import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import Typography from '@mui/material/Typography';
import Autocomplete from '#component/form/autocomplete';
import InputField from '#component/form/input';
import { CustomFieldsCnt, customFieldStyle } from '#component/shipment/form/shipment/form/style';

const CustomFields = ({ customFields }) => {
  const methods = useFormContext();
  const { control, formState } = methods || {};
  const error = formState?.errors?.customFieldsContainer?.message;

  if (!customFields?.length) return null;

  return (
    <>
      <CustomFieldsCnt hasError={!!error}>
        {customFields.map((field, index) => {
          const { label, selectOptions } = field;
          const name = `customFields[${index}].value`;

          if (selectOptions) {
            return (
              <Controller
                key={label}
                name={name}
                control={control}
                render={({ field: controllerField, fieldState }) => (
                  <Autocomplete
                    {...controllerField}
                    meta={fieldState}
                    options={selectOptions}
                    value={controllerField.value ?? null}
                    onChange={(e, value) => controllerField.onChange(value)}
                    inputProps={{ label, variant: 'outlined' }}
                    style={customFieldStyle}
                  />
                )}
              />
            );
          }

          return (
            <Controller
              key={label}
              name={name}
              control={control}
              render={({ field: controllerField, fieldState }) => (
                <InputField
                  {...controllerField}
                  meta={fieldState}
                  variant="outlined"
                  label={label}
                  style={customFieldStyle}
                />
              )}
            />
          );
        })}
      </CustomFieldsCnt>
      {error && <Typography align="left" color="error">{error}</Typography>}
    </>
  );
};

export default React.memo(CustomFields);
